import type { PluginConfig as AkPluginTableConfig } from '@atlaskit/editor-plugin-table/types';

import { EDITOR_TABLE_ADD_COLUMN_WITH_CUSTOM_STEP } from '../featureFlags';

type FeatureFlags = { [flag: string]: any };

export const getTableOptions = (featureFlags: FeatureFlags): AkPluginTableConfig => {
	return {
		allowBackgroundColor: true,
		allowColumnResizing: true,
		allowColumnSorting: true,
		allowDistributeColumns: true,
		allowHeaderColumn: true,
		allowHeaderRow: true,
		allowMergeCells: true,
		allowNumberColumn: true,
		allowControls: true,
		stickyHeaders: true,
		allowAddColumnWithCustomStep: Boolean(featureFlags[EDITOR_TABLE_ADD_COLUMN_WITH_CUSTOM_STEP]),
	};
};
